import { useState } from "react";
import { UserPlus, Search } from "lucide-react";
import { toast } from "sonner";
import { useProto } from "./ProtoContext";

export const RequestPerson = ({ initial = "" }) => {
  const { role } = useProto();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(initial);
  const [note, setNote] = useState("");
  if (role === "pastor") {
    return (
      <button
        className="w-full mt-6 h-14 rounded-[12px] border border-dashed border-line text-ink-soft font-medium inline-flex items-center justify-center gap-2 hover:border-brand hover:text-brand transition-colors"
        onClick={() => toast("Add a person", { description: "Opens a short form: name, phone, email. Care checks for possible duplicates first." })}
        data-testid="add-person-btn"
      >
        <UserPlus size={18} /> Add a person
      </button>
    );
  }
  if (!open) {
    return (
      <button className="w-full mt-6 py-4 min-h-[44px] text-ink-soft text-center flex flex-wrap items-center justify-center gap-x-2 gap-y-1 hover:text-brand transition-colors" onClick={() => setOpen(true)} data-testid="request-person-open">
        <Search size={16} /> Can't find someone? <span className="underline underline-offset-4">Ask to have them added</span>
      </button>
    );
  }
  const send = () => {
    toast.success("Request sent", { description: `Pastor David will add ${name || "them"} — or let you know if they're already here under another name.` });
    setOpen(false); setName(""); setNote("");
  };
  return (
    <div className="mt-6 tint p-5" data-testid="request-person-form">
      <p className="t-name-sm">Who should we add?</p>
      <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Their name" className="field mt-4 h-12 px-4 text-base" data-testid="request-person-name" />
      <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="How do you know them? (optional)" className="field mt-2 h-12 px-4 text-base" data-testid="request-person-note" />
      <div className="flex gap-2 mt-4">
        <button onClick={() => setOpen(false)} className="h-12 px-5 rounded-full text-ink-soft" data-testid="request-person-cancel">Cancel</button>
        <button onClick={send} disabled={!name.trim()} className="btn btn-primary flex-1" data-testid="request-person-send">Send request</button>
      </div>
    </div>
  );
};
